import React from 'react';

const AnalyticsDetailModal = ({ isOpen, onClose, platform, data, timeRange }) => {
  if (!isOpen) return null;

  const getPlatformData = () => {
    switch (platform) {
      case 'facebook':
        return {
          title: 'Facebook Analytics Détail',
          icon: 'fab fa-facebook',
          color: '#1877F2',
          metrics: [
            { label: 'Abonnés', value: data?.followers || 0, icon: 'fas fa-users' },
            { label: 'Portée', value: data?.reach || 0, icon: 'fas fa-eye' },
            { label: 'Engagement', value: data?.engagement || 0, icon: 'fas fa-heart' },
            { label: 'J\'aime de la page', value: data?.pageLikes || 0, icon: 'fas fa-thumbs-up' },
            { label: 'Portée des publications', value: data?.postReach || 0, icon: 'fas fa-bullhorn' },
            { label: 'Engagement des publications', value: data?.postEngagement || 0, icon: 'fas fa-comments' },
            { label: 'Partages', value: data?.shares || 0, icon: 'fas fa-share' },
            { label: 'Tendance', value: data?.trend || '+0%', icon: 'fas fa-chart-line' }
          ]
        };
      case 'google':
        return {
          title: 'Google Analytics Détail',
          icon: 'fab fa-google',
          color: '#4285F4',
          metrics: [
            { label: 'Sessions', value: data?.sessions || 0, icon: 'fas fa-chart-line' },
            { label: 'Pages vues', value: data?.pageViews || 0, icon: 'fas fa-eye' },
            { label: 'Taux de rebond', value: `${data?.bounceRate || 0}%`, icon: 'fas fa-percentage' },
            { label: 'Durée moyenne de session', value: `${data?.avgSessionDuration || 0} min`, icon: 'fas fa-clock' },
            { label: 'Tendance', value: data?.trend || '+0%', icon: 'fas fa-trending-up' }
          ]
        };
      case 'instagram':
        return {
          title: 'Instagram Analytics Détail',
          icon: 'fab fa-instagram',
          color: '#E4405F',
          metrics: [
            { label: 'Abonnés', value: data?.followers || 0, icon: 'fas fa-users' },
            { label: 'Portée', value: data?.reach || 0, icon: 'fas fa-eye' },
            { label: 'Engagement', value: data?.engagement || 0, icon: 'fas fa-heart' },
            { label: 'Impressions', value: data?.impressions || 0, icon: 'fas fa-eye' },
            { label: 'J\'aime', value: data?.likes || 0, icon: 'fas fa-heart' },
            { label: 'Commentaires', value: data?.comments || 0, icon: 'fas fa-comments' },
            { label: 'Tendance', value: data?.trend || '+0%', icon: 'fas fa-chart-line' }
          ]
        };
      case 'cloudflare':
        return {
          title: 'Cloudflare Analytics Détail',
          icon: 'fas fa-cloud',
          color: '#F38020',
          metrics: [
            { label: 'Requêtes', value: data?.requests || 0, icon: 'fas fa-globe' },
            { label: 'Bande passante', value: `${data?.bandwidth || 0} GB`, icon: 'fas fa-download' },
            { label: 'Menaces bloquées', value: data?.threats || 0, icon: 'fas fa-shield-alt' },
            { label: 'Temps de fonctionnement', value: `${data?.uptime || 0}%`, icon: 'fas fa-percentage' },
            { label: 'Tendance', value: data?.trend || '+0%', icon: 'fas fa-chart-line' }
          ]
        };
      default:
        return {
          title: 'Analytics Détail',
          icon: 'fas fa-chart-bar',
          color: '#f64a3e',
          metrics: []
        };
    }
  };

  const platformData = getPlatformData();

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="analytics-detail-modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <div className="modal-title">
            <i className={platformData.icon} style={{ color: platformData.color, marginRight: '10px' }}></i>
            {platformData.title}
          </div>
          <button className="modal-close" onClick={onClose}>
            <i className="fas fa-times"></i>
          </button>
        </div>
        
        <div className="modal-content">
          <div className="time-range-info">
            <i className="fas fa-calendar-alt"></i>
            <span>Période: {timeRange === '1d' ? '24 dernières heures' : 
                           timeRange === '7d' ? '7 derniers jours' : 
                           timeRange === '30d' ? '30 derniers jours' : 
                           '90 derniers jours'}</span>
          </div>
          
          <div className="metrics-grid">
            {platformData.metrics.map((metric, index) => (
              <div key={index} className="detail-metric-card">
                <div className="detail-metric-icon">
                  <i className={metric.icon}></i>
                </div>
                <div className="detail-metric-content">
                  <div className="detail-metric-value">{metric.value}</div>
                  <div className="detail-metric-label">{metric.label}</div>
                </div>
              </div>
            ))}
          </div>
          
          <div className="analytics-summary">
            <h4>Résumé des performances</h4>
            <div className="summary-content">
              <div className="summary-item">
                <i className="fas fa-chart-line"></i>
                <span>Données mises à jour en temps réel</span>
              </div>
              <div className="summary-item">
                <i className="fas fa-sync-alt"></i>
                <span>Dernière mise à jour: {new Date().toLocaleString('fr-FR')}</span>
              </div>
              <div className="summary-item">
                <i className="fas fa-info-circle"></i>
                <span>Source: API {platformData.title}</span>
              </div>
            </div>
          </div>
        </div>
        
        <div className="modal-footer">
          <button className="btn-secondary" onClick={onClose}>
            Fermer
          </button>
          <button className="btn-primary">
            <i className="fas fa-download"></i>
            Exporter les données
          </button>
        </div>
      </div>
    </div>
  );
};

export default AnalyticsDetailModal;
